
import { Vue, Component, Prop, mixins } from 'nuxt-property-decorator'
import ImageUrlS3 from '~/mixins/imageUrlS3'

@Component
export default class PageNavComponent extends mixins(ImageUrlS3) {
  @Prop({ required: true }) pages: Record<string, any>[]
}
